(function () {
  'use strict';

  var BUTTON_SELECTOR = '.moonbundle-quantity-btn';
  var INPUT_SELECTOR = '.moonbundle-quantity-input';
  var ITEM_SELECTOR = '.moonbundle-cart-item-quantity';
  var updatingItems = new Set();

  function setButtonsDisabled(buttons, disabled) {
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].disabled = disabled;
      buttons[i].setAttribute('aria-disabled', disabled);
    }
  }

  function notifyMoonbundleInputChange(input, quantity) {
    input.value = quantity;
    input.setAttribute('value', quantity);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest(BUTTON_SELECTOR);

      if (!button) {
        return;
      }

      var action = button.getAttribute('data-action');

      if (action !== 'increase' && action !== 'decrease') {
        return;
      }

      var itemKey = button.getAttribute('data-item-key');
      var container = button.closest(ITEM_SELECTOR);
      var input = container.querySelector(INPUT_SELECTOR);
      var qiCart = window.BSS_B2B.qi.utils.cart;
      var rule = qiCart.getAppliedRules().get(itemKey);

      if (!rule || rule.qty_increment_type !== 0) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (updatingItems.has(itemKey)) {
        return;
      }

      var currentQuantity = Number(input.value);
      var changeType = action === 'increase' ? 'UpQuantity' : 'DownQuantity';
      var nextQuantity = qiCart.calculateNearestQuantity(
        rule,
        currentQuantity,
        changeType
      );

      if (nextQuantity === currentQuantity) {
        return;
      }

      var containerButtons = container.querySelectorAll(BUTTON_SELECTOR);

      updatingItems.add(itemKey);
      setButtonsDisabled(containerButtons, true);

      notifyMoonbundleInputChange(input, nextQuantity);

      window.setTimeout(function () {
        updatingItems.delete(itemKey);
        setButtonsDisabled(containerButtons, false);
      }, 800);
    },
    true
  );
})();